import {Box, Flex, Image, Text} from '@chakra-ui/react'
import BackGround from '@assets/images/learn/bg-vocabulary-result.png'
import BookImage from '@assets/images/learn/book.png'
import ArrowRightIcon from '@assets/svgs/learn/arrow_right_6.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'

const Header = ({vocabulariesOverview}: {vocabulariesOverview: any}) => {
  const location = useLocation()
  const {
    setId,
    setName = vocabulariesOverview?.set_overview_header?.set_name_en,
    topicName,
    setNameVi = vocabulariesOverview?.set_overview_header?.set_name_vi,
    entry_point,
    task_id,
  } = location.state || {}
  const navigate = useNavigate()

  const handleClickBtn = () => {
    navigate(PATH.LEARN_VOCABULARY, {
      state: {
        setId,
        setName,
        topicName,
        entry_point,
        task_id,
      },
    })
  }

  return (
    <Box
      h={'320px'}
      bgImage={BackGround}
      bgSize={'cover'}
      bgRepeat={'no-repeat'}>
      <Flex
        className="container-xl"
        flexWrap={{base: 'wrap', md: 'unset'}}
        px={{base: '20px', md: '40px'}}
        pt={{base: '30px', md: '50px'}}
        gap={'32px'}
        alignItems={'center'}>
        <Image src={BookImage} w={{base: '60px', md: 'unset'}} />
        <Box flex={1}>
          <Box maxW={'450px'}>
            <Text fontSize={'14px'} color={'#263238'}>
              {topicName}
            </Text>
            <Text
              fontSize={{base: '18px', md: '24px'}}
              fontWeight={600}
              color={'#263238'}>
              {setName}
            </Text>
            <Text fontSize={'16px'} color={'#546E7A'}>
              {setNameVi}
            </Text>
          </Box>
        </Box>
        <Flex flexBasis={{base: '100%', md: 'unset'}} justifyContent={'center'}>
          <Flex
            gap={'8px'}
            p={{base: '12px 20px', md: '16px 40px'}}
            bg={'#FA8C16'}
            borderRadius={'12px'}
            cursor={'pointer'}
            onClick={handleClickBtn}>
            <Text fontSize={'16px'} fontWeight={700} color={'white'}>
              Bắt đầu học
            </Text>
            <Image src={ArrowRightIcon} />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Header
